// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.analytics.properties.RentalManagerUserAnalyticsPropertiesWebApiHandler

import type { QueryOptions, UseQueryOptions } from '@zg-rentals/react-query5';
import { useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  RentalManagerUserAnalyticsPropertiesWebApiHandler_getCompsForListing,
  RentalManagerUserAnalyticsPropertiesWebApiHandler_getCompsForListing_Path,
  RentalManagerUserAnalyticsPropertiesWebApiHandler_getListingPerformanceDailyBreakdownV2,
  RentalManagerUserAnalyticsPropertiesWebApiHandler_getListingPerformanceDailyBreakdownV2_Path,
  RentalManagerUserAnalyticsPropertiesWebApiHandler_getListingPerformanceV2,
  RentalManagerUserAnalyticsPropertiesWebApiHandler_getListingPerformanceV2_Path,
  RentalManagerUserAnalyticsPropertiesWebApiHandler_getListingRanking,
  RentalManagerUserAnalyticsPropertiesWebApiHandler_getListingRanking_Path,
} from '@zg-rentals/ts-rental-manager-api-client';

import type {
  CustomerAnalyticsListingPerformanceDailyBreakdownDtoV2,
  CustomerAnalyticsListingPerformanceDtoV2,
  ListingAlias,
  ListingCompsResponseDto,
  ListingRankingRequestDto,
  ListingRankingResponseDto,
} from '@zg-rentals/ts-rental-manager-api-client';

interface GetCompsForListingParams {
  listingAlias?: ListingAlias;
  radius?: number;
  zrnNumber: string;
}
interface GetListingPerformanceDailyBreakdownV2Params {
  endDayYyyyMmDd: string;
  includeFreeStats?: boolean;
  includeMarketInsights?: boolean;
  listingAlias: ListingAlias;
  startDayYyyyMmDd: string;
}
interface GetListingPerformanceV2Params {
  endDayYyyyMmDd: string;
  includeFreeStats?: boolean;
  includeMarketInsights: boolean;
  listingAlias?: string;
  startDayYyyyMmDd: string;
}

export type RentalManagerUserAnalyticsPropertiesWebApiHandler_getCompsForListing_Options = UseQueryOptions<
  ListingCompsResponseDto,
  unknown,
  ListingCompsResponseDto,
  readonly [string, GetCompsForListingParams]
>;

const RentalManagerUserAnalyticsPropertiesWebApiHandler_getCompsForListing_GetKey = (
  getParams: GetCompsForListingParams,
) => [RentalManagerUserAnalyticsPropertiesWebApiHandler_getCompsForListing_Path, getParams] as const;

export const RentalManagerUserAnalyticsPropertiesWebApiHandler_getCompsForListing_queryOptions = (
  getParams: GetCompsForListingParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerUserAnalyticsPropertiesWebApiHandler_getCompsForListing_GetKey(getParams),
    queryFn: () => RentalManagerUserAnalyticsPropertiesWebApiHandler_getCompsForListing(getParams, httpClient),
  }) as const satisfies QueryOptions;

/**
 * Get competitor comps for a listing
 */
export const useRentalManagerUserAnalyticsPropertiesWebApiHandler_getCompsForListing = (
  getParams: GetCompsForListingParams,
  {
    httpClient,
    ...options
  }: Omit<RentalManagerUserAnalyticsPropertiesWebApiHandler_getCompsForListing_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...RentalManagerUserAnalyticsPropertiesWebApiHandler_getCompsForListing_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useRentalManagerUserAnalyticsPropertiesWebApiHandler_getCompsForListing.getKey =
  RentalManagerUserAnalyticsPropertiesWebApiHandler_getCompsForListing_GetKey;

export type RentalManagerUserAnalyticsPropertiesWebApiHandler_getListingPerformanceDailyBreakdownV2_Options =
  UseQueryOptions<
    CustomerAnalyticsListingPerformanceDailyBreakdownDtoV2,
    unknown,
    CustomerAnalyticsListingPerformanceDailyBreakdownDtoV2,
    readonly [string, GetListingPerformanceDailyBreakdownV2Params]
  >;

const RentalManagerUserAnalyticsPropertiesWebApiHandler_getListingPerformanceDailyBreakdownV2_GetKey = (
  getParams: GetListingPerformanceDailyBreakdownV2Params,
) => [RentalManagerUserAnalyticsPropertiesWebApiHandler_getListingPerformanceDailyBreakdownV2_Path, getParams] as const;

export const RentalManagerUserAnalyticsPropertiesWebApiHandler_getListingPerformanceDailyBreakdownV2_queryOptions = (
  getParams: GetListingPerformanceDailyBreakdownV2Params,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerUserAnalyticsPropertiesWebApiHandler_getListingPerformanceDailyBreakdownV2_GetKey(getParams),
    queryFn: () =>
      RentalManagerUserAnalyticsPropertiesWebApiHandler_getListingPerformanceDailyBreakdownV2(getParams, httpClient),
  }) as const satisfies QueryOptions;

/**
 * Get listing performance daily breakdown for custom time range
 */
export const useRentalManagerUserAnalyticsPropertiesWebApiHandler_getListingPerformanceDailyBreakdownV2 = (
  getParams: GetListingPerformanceDailyBreakdownV2Params,
  {
    httpClient,
    ...options
  }: Omit<
    RentalManagerUserAnalyticsPropertiesWebApiHandler_getListingPerformanceDailyBreakdownV2_Options,
    'queryFn' | 'queryKey'
  > & { httpClient?: Client } = {},
) => {
  return useQuery({
    ...RentalManagerUserAnalyticsPropertiesWebApiHandler_getListingPerformanceDailyBreakdownV2_queryOptions(getParams, {
      httpClient,
    }),
    ...options,
  });
};
useRentalManagerUserAnalyticsPropertiesWebApiHandler_getListingPerformanceDailyBreakdownV2.getKey =
  RentalManagerUserAnalyticsPropertiesWebApiHandler_getListingPerformanceDailyBreakdownV2_GetKey;

export type RentalManagerUserAnalyticsPropertiesWebApiHandler_getListingPerformanceV2_Options = UseQueryOptions<
  CustomerAnalyticsListingPerformanceDtoV2,
  unknown,
  CustomerAnalyticsListingPerformanceDtoV2,
  readonly [string, GetListingPerformanceV2Params]
>;

const RentalManagerUserAnalyticsPropertiesWebApiHandler_getListingPerformanceV2_GetKey = (
  getParams: GetListingPerformanceV2Params,
) => [RentalManagerUserAnalyticsPropertiesWebApiHandler_getListingPerformanceV2_Path, getParams] as const;

export const RentalManagerUserAnalyticsPropertiesWebApiHandler_getListingPerformanceV2_queryOptions = (
  getParams: GetListingPerformanceV2Params,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerUserAnalyticsPropertiesWebApiHandler_getListingPerformanceV2_GetKey(getParams),
    queryFn: () => RentalManagerUserAnalyticsPropertiesWebApiHandler_getListingPerformanceV2(getParams, httpClient),
  }) as const satisfies QueryOptions;

/**
 * Get listing performance for custom time range
 */
export const useRentalManagerUserAnalyticsPropertiesWebApiHandler_getListingPerformanceV2 = (
  getParams: GetListingPerformanceV2Params,
  {
    httpClient,
    ...options
  }: Omit<RentalManagerUserAnalyticsPropertiesWebApiHandler_getListingPerformanceV2_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...RentalManagerUserAnalyticsPropertiesWebApiHandler_getListingPerformanceV2_queryOptions(getParams, {
      httpClient,
    }),
    ...options,
  });
};
useRentalManagerUserAnalyticsPropertiesWebApiHandler_getListingPerformanceV2.getKey =
  RentalManagerUserAnalyticsPropertiesWebApiHandler_getListingPerformanceV2_GetKey;

export type RentalManagerUserAnalyticsPropertiesWebApiHandler_getListingRanking_Options = UseQueryOptions<
  ListingRankingResponseDto,
  unknown,
  ListingRankingResponseDto,
  readonly [string, ListingRankingRequestDto]
>;

const RentalManagerUserAnalyticsPropertiesWebApiHandler_getListingRanking_GetKey = (
  postData: ListingRankingRequestDto,
) => [RentalManagerUserAnalyticsPropertiesWebApiHandler_getListingRanking_Path, postData] as const;

export const RentalManagerUserAnalyticsPropertiesWebApiHandler_getListingRanking_queryOptions = (
  postData: ListingRankingRequestDto,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerUserAnalyticsPropertiesWebApiHandler_getListingRanking_GetKey(postData),
    queryFn: () => RentalManagerUserAnalyticsPropertiesWebApiHandler_getListingRanking(postData, httpClient),
  }) as const satisfies QueryOptions;

/**
 * Get listing ranking among competitors
 */
export const useRentalManagerUserAnalyticsPropertiesWebApiHandler_getListingRanking = (
  postData: ListingRankingRequestDto,
  {
    httpClient,
    ...options
  }: Omit<RentalManagerUserAnalyticsPropertiesWebApiHandler_getListingRanking_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...RentalManagerUserAnalyticsPropertiesWebApiHandler_getListingRanking_queryOptions(postData, { httpClient }),
    ...options,
  });
};
useRentalManagerUserAnalyticsPropertiesWebApiHandler_getListingRanking.getKey =
  RentalManagerUserAnalyticsPropertiesWebApiHandler_getListingRanking_GetKey;
